// extracted by mini-css-extract-plugin
export default {"intro":"intro_intro__lQoCz","introContent":"intro_introContent__fXqx5","cv":"intro_cv__GU3Rp","socials":"intro_socials__LCu5d"};